export default __webpack_public_path__ + "static/media/gym.64bb5e02.svg";